export const FETCH_AFFIARS_OF_SURGERY_REQUEST =
  "FETCH_AFFIARS_OF_SURGERY_REQUEST";
export const FETCH_AFFIARS_OF_SURGERY_SUCCESS =
  "FETCH_AFFIARS_OF_SURGERY_SUCCESS";
export const FETCH_AFFIARS_OF_SURGERY_FAIL = "FETCH_AFFIARS_OF_SURGERY_FAIL";

export const CREATE_AFFIARS_OF_SURGERY_REQUEST =
  "CREATE_AFFIARS_OF_SURGERY_REQUEST";
export const CREATE_AFFIARS_OF_SURGERY_SUCCESS =
  "CREATE_AFFIARS_OF_SURGERY_SUCCESS";
export const CREATE_AFFIARS_OF_SURGERY_FAIL = "CREATE_AFFIARS_OF_SURGERY_FAIL";

export const UPDATE_AFFIARS_OF_SURGERY_REQUEST =
  "UPDATE_AFFIARS_OF_SURGERY_REQUEST";
export const UPDATE_AFFIARS_OF_SURGERY_SUCCESS =
  "UPDATE_AFFIARS_OF_SURGERY_SUCCESS";
export const UPDATE_AFFIARS_OF_SURGERY_FAIL = "UPDATE_AFFIARS_OF_SURGERY_FAIL";
